import React, { createContext, useState } from 'react';

export const VirtualAccountContext = createContext({
  payment_details: null,
  show_modal: false,
  setPaymentDetails: () => {},
  closeModal: () => {},
  openModal: () => {}
});

export const VirtualAccountProvider = ({ children }) => {
  const [payment_details, setPaymentDetails] = useState(null);
  const [show_modal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  return (
    <VirtualAccountContext.Provider
      value={{ payment_details, show_modal, setPaymentDetails, closeModal, openModal }}
    >
      {children}
    </VirtualAccountContext.Provider>
  );
};
